import { render, staticRenderFns } from "./BotonAtras.vue?vue&type=template&id=ddaa63d4&scoped=true&"
import script from "./BotonAtras.vue?vue&type=script&lang=js&"
export * from "./BotonAtras.vue?vue&type=script&lang=js&"
import style0 from "./BotonAtras.vue?vue&type=style&index=0&id=ddaa63d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaa63d4",
  null
  
)

export default component.exports